export default __webpack_public_path__ + "static/media/1314 cutlery top.c5b15da0.png";